import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="overlays--modal-dialog"
export default class extends Controller {
  connect() {
    this.element.showModal();
    this.element.addEventListener("close", this.clearModal.bind(this));
    document.querySelector("body").classList.add("overflow-y-hidden");
  }

  clearModal() {
    document.getElementById("overlay_modal_dialog").innerHTML = "";
    document.querySelector("body").classList.remove("overflow-y-hidden");
  }
}
